import React, { memo, useEffect, useState } from "react";
import { site } from "../../../_foundation/constants/site";

interface ImageProps {
  src: string;
  alt?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  transparent?: boolean;
  styles?: React.CSSProperties;
  priority?: boolean;
  showFallback?: boolean;
  isSticky?: boolean;
  onLoadError?: () => void;
  onLoadComplete?: () => void;
  fill?: boolean;
}

const ImageComponent: React.FC<ImageProps> = ({
  src,
  alt = "",
  className,
  width,
  height,
  transparent,
  styles = {},
  priority = false,
  showFallback = true,
  isSticky = false,
  fill = false,
  onLoadError,
  onLoadComplete,
  // hideSkeletonLoader = false,
  // skeletonLoaderHeight,
  // skeletonVariant,
}) => {
  const [hasError, setHasError] = useState(false);
  const isBotCrawling = (window as any)?.["__isPrerender__"] || false;

  // reset error when src changes (VERY IMPORTANT)
  useEffect(() => {
    setHasError(false);
  }, [src]);

  const finalSrc = !isBotCrawling && hasError && showFallback ? site.defaultImage : src;

  return (
    <img
      className={className}
      src={finalSrc}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      style={{
        margin: "0 auto",
        display: "block",
        objectFit: fill ? "cover" : isSticky ? "contain" : "cover",
        opacity: transparent ? 0 : 1,
        width,
        height,
        ...styles,
      }}
      onLoad={() => {
        onLoadComplete?.();
      }}
      onError={() => {
        console.error("[CMS IMAGE ERROR]", src);

        // ⏱ delay hiding to avoid CDN race conditions
        setTimeout(() => {
          setHasError(true);
          onLoadError?.();
        }, 300);
      }}
      {...({ fetchPriority: priority ? "high" : "auto" } as any)}
    />
  );
};

export const ImageLayout = memo(ImageComponent);
